<template>
    <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
        <div class="m-portlet__head preview">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">{{ labels.product_stocks }}</h3>
                </div>
            </div>
        </div>
        <div class="m-portlet__body">
            <div class="m-portlet__body-progress"></div>
            <div class="m-portlet__body" m-hidden-height="345">
                <div class="table-responsive custom_table_scroll">
                    <table class="table">
                        <thead class="thead-light">
                            <tr>
                                <th>{{ labels['brand_name'] }}</th>
                                <th>{{ labels['collection_name'] }}</th>
<!--                                <th>{{ labels['product_name'] }}</th>-->
<!--                                <th>{{ labels['available_cip'] }}</th>-->
                                <th>{{ labels['place_storage'] }}</th>
                                <th>{{ labels['open'] }}</th>
                                <th>{{ labels['loaned'] }}</th>
                                <th>{{ labels['package_type'] }}</th>
                                <th>{{ labels['package_capacity'] }}</th>
                                <th>{{ labels['alert_status'] }}</th>
                                <th v-if="fullProductManagementAccess">#</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(stock, index) in stocks" :key="'stock_' + (index+1)" class="larger-text">
                                <td>{{ stock.brandName }}</td>
                                <td>{{ stock.collectionName }}</td>
<!--                                <td>{{ stock.productName }}</td>-->
<!--                                <td>{{ labels['availability_' + stock.availableCIP] }}</td>-->
                                <td>{{ stock.codeStorage }}</td>
                                <td>{{ displayYesNo(stock.isOpened) }}</td>
                                <td>{{ displayYesNo(stock.isLoaned) }}</td>
                                <td>{{ getName(stock.typePackId, 'type_pack_id', 'type_packs') }}</td>
                                <td>{{ getName(stock.packageCapacityId, 'package_capacity_id', 'package_capacities') }}</td>
                                <td>{{ labels[stock.status] }}</td>
                                <td v-if="fullProductManagementAccess">
                                    <router-link :to="{ name: 'ProductFormExt', query: { productId: stock.productId, tab: 6 }}" class="btn btn-primary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill btn-sm">
                                        <i class="la la-eye"></i>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import algoliaStocksAction from '../../../assets/js/algoliaStocksMixin';

export default {
  name: 'PreviewStock',
  mixins: [algoliaStocksAction],
  props: ['previewProduct'],
  data() {
    return {
      stocks: [],
    };
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      stockIndex: (state) => state.stocks.stockIndex,
    }),
    ...mapGetters([
      'getName',
      'fullProductManagementAccess',
    ]),
  },
  methods: {
    displayYesNo(value) {
      return value === 'yes' || value === 'true' ? this.labels.yes : this.labels.no;
    },
  },
  async mounted() {
    this.stocks = await this.getAlgoliaStock(this.previewProduct.productId);
    // get the stock info
  },
  created() {
    this.stockIndex.clearCache();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Products/Preview/PreviewStock.vue